import { configureStore } from "@reduxjs/toolkit";

import orderSlice from "./order-slice";
import authSlice from "./auth-slice";
import rfzoTherapySlice from "./rfzoTherapy-slice";
import searchInputSlice from "./search-input-slice";
import adminCmsSlice from "./admin-cms-slice";
import patientsSlice from "./patients-slice";
import videoConsultSlice from "./videoConsult-slice";
import consultOrderSlice from "./consultOrder-slice";
import { initializeAuthErrorHandler } from "../axios/axios";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    order: orderSlice.reducer,
    rfzoTherapy: rfzoTherapySlice.reducer,
    searchInput: searchInputSlice.reducer,
    adminCMS: adminCmsSlice.reducer,
    patients: patientsSlice.reducer,
    videoConsult: videoConsultSlice.reducer,
    consultOrder: consultOrderSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Initialize auth error handler for axios interceptor
initializeAuthErrorHandler(store, authSlice.actions);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
